import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/performance/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/performance/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/performance', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/performance', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/performance/' + id)
  }
}
